export default "__VITE_ASSET__BySjitoG__"